<div class="mb-1" [ngClass]="{'mt-1rem':!isArchive}">
  <div class="ptb-archive" *ngIf="isArchive">
    <div class="mt-12 ml-1-5 archive-banner width-max-content">
      <div class="archive-btn">
        <span class="version-general-header">Archive Version : {{archiveVersion}}</span>
      </div>
      <div role="button" class="back-close-btn" tabindex="0" (click)="BackToCurrentContent()" (keyup.enter)="BackToCurrentContent()" tabindex="0">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="current-content-back-arrow-icon" alt="Arrow Left">
        <span class="underline">Back to Current GARS Version</span>
      </div>
    </div>
  </div>
  <div id="tc-container" class="content-container">

    <app-terms-and-condition-content></app-terms-and-condition-content>
  </div>
</div>
